export { SocoCommonModule } from '@app/soco/common/common_module';

// DSS Documentation on SocoSearchPipe - http://tiny.sc/cgsocosearchpipe
export { SocoSearchPipe } from '@app/soco/common/soco-search.pipe';
// DSS Documentation on SocoSystemMessageComponent - http://tiny.sc/cgsocosystemmessagecomponent
export { SocoSystemMessageComponent } from '@app/soco/common/soco-system-message.component';
